<template>
    <div class="leading-none flex items-center justify-center -mb-10 z-50">
        <div class="pt-12 pl-16 mb-12 mr-16 flex items-center">
            <label
                class="flex items-center mr-16 first-letter:capitalize"
                v-for="item in items"
                :class="{'cursor-pointer': activateClick && clickable, 'opacity-60': selectedTab && ((parentRef && selectedTab === item) || (!parentRef && selectedTab !== item)) && clickable}"
            >
                <span
                    class="w-18 h-18 rounded-sm mr-4"
                    :style="{backgroundColor: getTabColor(item)}"
                ></span>
                {{ getTranslation(item) }}
                <input
                    type="checkbox"
                    :id="item"
                    :value="item"
                    :checked="!!selectedTab && selectedTab === item"
                    class="hidden"
                    @click="handleClick"
                >
            </label>
        </div>
    </div>
</template>
<script>
export default {
    name: "CustomLegend",
    props: {
        items: Array,
        colors: Array,
        clickable: {
            type: Boolean,
            default: false
        },
        translationKey: String,
        translationTail: String,
        selectedTab: String||null,
        parentRef: Object,
    },
    data() {
        return {
            activateClick: false,
        }
    },
    methods: {
        getTabColor(tab) {
            return this.colors[this.items.indexOf(tab)];
        },
        getTranslation(tab) {
            if (!this.translationKey) return tab;
            return this.$t(this.translationKey + '.' + tab + (this.translationTail ? '.' + this.translationTail : ''));
        },
        handleClick(event) {
            if (this.activateClick && this.clickable) {
                if (this.parentRef) {
                    this.parentRef.resetSeries();
                    if (event.target.value !== this.selectedTab) this.parentRef.hideSeries(this.getTranslation(event.target.value));
                }
                const value = event.target.value;
                const checked = event.target.checked;
                if (!checked) event.preventDefault();
                this.$emit('update', value);
            }
        },
    },
    beforeMount() {
        if (this.clickable) {
            this.activateClick = true;
        }
    }
}
</script>
<style scoped>

</style>